import React, { useState } from 'react';
import styles from './ListItem.module.sass';

const ListItem = ({children, label, iteration, hasChildren, isOpen, isActive}: Props) => {
    const [state, setState] = useState({
        iteration: iteration || 0,
        hasChildren: hasChildren,
        isOpen: isOpen
    });

    const handleOpenClick = () => setState({...state, isOpen: !state.isOpen});

    return <>
        <div className={`
            ${styles['dropdown__item']}
            ${state.isOpen ? styles['dropdown__item--isOpen'] : ''}
            ${!state.hasChildren ? styles['dropdown__item--isChild'] : ''}
            ${isActive ? styles['dropdown__item--active'] : ''}
        `}
            onClick={handleOpenClick}
        >
            <div className={styles[`dropdown__item-${state.iteration}`]} />
            { label }
        </div>
        { state.isOpen && children }
    </>
}

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    hasChildren: boolean
    iteration?: boolean
    isOpen?: boolean
    label?: any
    isActive?: boolean
}

export default ListItem;